export default {"src":"/_next/static/media/trade_bet.efbefe90.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};